import { composeClassNames, ifDefined } from "@faedev/editor-utils";
import { CSSProperties } from "react";
import constants from "src/constants";
import Favourite from "src/icons/Favourite";
import Favourite_full from "src/icons/Favourite-full";
import { sFavorite } from "src/styles/sFavorite.module.scss";
import { TypeColorStatus } from "src/types/TypeColorStatus";
import { VariantSize } from "src/types/VariantSize";

type Props = {
  value?: boolean | null | undefined;
  setByUser?: boolean | null | undefined;
  size?: VariantSize | null | undefined;
  className?: (string | string) | null | undefined;
  style?: CSSProperties | null | undefined;
  colors: TypeColorStatus;
};

function Favorite({ value, setByUser, size, className, style, colors }: Props) {
  return constants.Show.navFavorite && value !== undefined ? (
    <div
      style={style}
      className={composeClassNames([sFavorite, size, className, "favorite"])}
    >
      {ifDefined(
        value,
        (value) => (
          <div>
            {ifDefined(
              setByUser,
              (value) => (
                <Favourite_full color={colors ? colors.active : null} />
              ),
              () => (
                <Favourite color={colors ? colors.default : null} />
              )
            )}
          </div>
        ),
        () => null
      )}
    </div>
  ) : null;
}

export default Favorite;
